module.exports = __webpack_public_path__ + "static/5013-Icon-128c4eb7fec623844509f3dc2dfda0ac.png";